export const getTrustPayload = async () => {
    // componentDidMount only runs client side, no need to check for window
    if (window.trustApi) {
        // Payload is available immediately
        return Promise.resolve(window.trustApi.getTrustPayload());
    }
    // try again in a few seconds
    return new Promise((resolve) => {
        setTimeout(() => {
            if (window.trustApi) {
                // Payload is now available, return it
                resolve(window.trustApi.getTrustPayload());
            } else {
                // give up
                resolve('');
            }
        }, 2000);
    });
};

export default {
    getTrustPayload
};
